var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "code",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.358,
    height: 53.684,
    viewBox: "0 0 53.358 53.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_175964",
    "data-name": "Group 175964",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175960",
    "data-name": "Group 175960",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175958",
    "data-name": "Group 175958",
    transform: "translate(14.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38345",
    "data-name": "Path 38345",
    d: "M415.788,228a1.089,1.089,0,0,1-.985-.623l-1.416-2.99a1.089,1.089,0,1,1,1.969-.932l1.416,2.99a1.09,1.09,0,0,1-.983,1.556Z",
    transform: "translate(-413.281 -222.835)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175959",
    "data-name": "Group 175959",
    transform: "translate(0 14.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38346",
    "data-name": "Path 38346",
    d: "M308.064,335.839a1.084,1.084,0,0,1-.5-.121l-2.941-1.514a1.089,1.089,0,1,1,1-1.937l2.941,1.514a1.089,1.089,0,0,1-.5,2.058Z",
    transform: "translate(-304.034 -332.146)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_175963",
    "data-name": "Group 175963",
    transform: "translate(0 35.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175961",
    "data-name": "Group 175961",
    transform: "translate(14.873 13.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38347",
    "data-name": "Path 38347",
    d: "M414.37,584.37a1.09,1.09,0,0,1-.984-1.555l1.416-2.99a1.089,1.089,0,1,1,1.969.932l-1.416,2.99A1.089,1.089,0,0,1,414.37,584.37Z",
    transform: "translate(-413.281 -579.202)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175962",
    "data-name": "Group 175962"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38348",
    "data-name": "Path 38348",
    d: "M305.125,484.422a1.089,1.089,0,0,1-.5-2.058l2.941-1.514a1.089,1.089,0,0,1,1,1.937l-2.941,1.514A1.086,1.086,0,0,1,305.125,484.422Z",
    transform: "translate(-304.034 -480.729)",
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_175971",
    "data-name": "Group 175971",
    transform: "translate(34.89 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175967",
    "data-name": "Group 175967",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175965",
    "data-name": "Group 175965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38349",
    "data-name": "Path 38349",
    d: "M561.4,228a1.09,1.09,0,0,1-.984-1.556l1.416-2.99a1.089,1.089,0,1,1,1.969.932l-1.416,2.99A1.089,1.089,0,0,1,561.4,228Z",
    transform: "translate(-560.314 -222.835)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175966",
    "data-name": "Group 175966",
    transform: "translate(13.348 14.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38350",
    "data-name": "Path 38350",
    d: "M659.45,335.839a1.089,1.089,0,0,1-.5-2.058l2.941-1.514a1.089,1.089,0,1,1,1,1.937l-2.941,1.514A1.085,1.085,0,0,1,659.45,335.839Z",
    transform: "translate(-658.36 -332.146)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_175970",
    "data-name": "Group 175970",
    transform: "translate(0 35.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175968",
    "data-name": "Group 175968",
    transform: "translate(0 13.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38351",
    "data-name": "Path 38351",
    d: "M562.82,584.37a1.089,1.089,0,0,1-.985-.623l-1.416-2.99a1.089,1.089,0,0,1,1.969-.932l1.416,2.99a1.09,1.09,0,0,1-.984,1.555Z",
    transform: "translate(-560.314 -579.201)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175969",
    "data-name": "Group 175969",
    transform: "translate(13.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38352",
    "data-name": "Path 38352",
    d: "M662.389,484.422a1.084,1.084,0,0,1-.5-.121l-2.941-1.514a1.089,1.089,0,0,1,1-1.937l2.941,1.514a1.089,1.089,0,0,1-.5,2.058Z",
    transform: "translate(-658.36 -480.729)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.4222095134ba5a8dfbd5350fac459498.svg";
export { ForwardRef as ReactComponent };